/* Real-user Web Vitals collector.

   Batches Core Web Vitals and beacons them to /api/analytics/vitals when the
   page is hidden/unloaded (sendBeacon survives tab close). Gives us REAL
   production performance numbers per page — p75 LCP/CLS/INP — viewable via
   GET /api/admin/analytics/vitals/summary. */
import { onCLS, onFCP, onINP, onLCP, onTTFB } from "web-vitals";

const API = process.env.REACT_APP_BACKEND_URL;
const queue = [];

function flush() {
  if (!queue.length || !API) return;
  const payload = JSON.stringify({ metrics: queue.splice(0), page: window.location.pathname });
  const url = `${API}/api/analytics/vitals`;
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(url, { method: "POST", body: payload, headers: { "Content-Type": "application/json" }, keepalive: true });
    }
  } catch {
    // Analytics must never break the app.
  }
}

function push(metric) {
  queue.push({
    name: metric.name,
    value: metric.value,
    rating: metric.rating,
    navigationType: metric.navigationType,
    page: window.location.pathname,
  });
}

export function installVitals() {
  try {
    onLCP(push);
    onCLS(push);
    onINP(push);
    onFCP(push);
    onTTFB(push);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") flush();
    });
    window.addEventListener("pagehide", flush);
  } catch {
    // web-vitals unsupported browser — skip silently.
  }
}
